import React from "react";
import TableCell from "./TableCell";
import SourceIcons from "./SourceIcons";

const TotalRow = ({ totals, intervals, showDaily, isAdmin }) => {
  if (!totals || !intervals) return null;

  const getIntervalTotalSourceTooltip = (intervalIndex) => {
    if (!isAdmin || !totals.intervalSourcesTotals?.[intervalIndex]) return null;

    const sources = totals.intervalSourcesTotals[intervalIndex];
    const hasData = Object.values(sources).some((count) => count > 0);

    if (!hasData) return null;

    return <SourceIcons sources={sources} size={25} />;
  };

  const getOverallTotalSourceTooltip = () => {
    if (!isAdmin || !totals.totalSources) return null;

    const hasData = Object.values(totals.totalSources).some(
      (count) => count > 0
    );
    if (!hasData) return null;

    return <SourceIcons sources={totals.totalSources} size={25} />;
  };

  return (
    <tr className="totalRow">
      <TableCell value="ИТОГО" />
      <TableCell value={`Всего компаний: ${totals.companies || 0}`} />
      <TableCell value={`Всего вакансий: ${totals.vacancies || 0}`} />
      <TableCell value={`Всего менеджеров: ${totals.managers || 0}`} />

      {intervals.map((_, intervalIndex) => {
        const total = totals.intervalTotals?.[intervalIndex] || 0;
        const tooltipContent = getIntervalTotalSourceTooltip(intervalIndex);
        return (
          <TableCell
            key={intervalIndex}
            value={total}
            center
            highlight={showDaily && total > 0}
            tooltipContent={isAdmin ? tooltipContent : null}
          />
        );
      })}
      <TableCell
        value={totals.totalResponds || 0}
        tooltipContent={isAdmin ? getOverallTotalSourceTooltip() : null}
      />
    </tr>
  );
};

export default TotalRow;
